import { t } from '@framework/i18n';
import { IFixedRuleType } from '../../../../../rules/IRuleType';
import { ConfirmWidgetValue } from '../IConfirmWidget';

/**
 * Regola fissa per validare che il campo sia stato confermato
 * o modificato.
 * Non è possibile lasciare il campo non confermato, ma in ogni
 * caso non possiamo eseguire la validazione finché si è
 * in compilazione di un'altra sezione/pagina.
 */
export const ConfirmWidgetRequiredRule: IFixedRuleType = {
  name: 'Conferma Richiesta',
  validator: schema => {
    return schema
      .required()
      .oneOf(
        [
          ConfirmWidgetValue.ConfirmedDefault,
          ConfirmWidgetValue.ConfirmedModified,
        ],
        t(
          'rules.confirm-widget-required.error',
          'È necessario confermare i dati mostrati oppure modificarli.',
        ),
      );
  },
};
